import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map, filter, dropRight,
} from 'lodash';
import {
  FileInput, Input, Select, SearchSelect, Checkbox, Textarea,
  Option,
} from '../../../../../components/base';
import {
  FINANCE_BANK_JOURNAL_FORM_FIELDS,
} from '../../../../../constants/finance/finance.constant';
import ListForm from '../../../../../components/ListForm/ListForm.component';

export default class BankJournalFormHeader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      form, coa, showEdit, onFormChange, isDebit, onSearchUnit,
      onSearchBankAccount, isReconciliation,
    } = this.props;
    const { value } = form;
    const { tipe = 0 } = value;
    let fields = { ...FINANCE_BANK_JOURNAL_FORM_FIELDS };
    let journalType = filter(fields, (o, i) => {
      return o.name === 'type';
    });
    let formType = filter(fields, (o, i) => {
      return o.name === 'tipe';
    });
    let rekeningSelector = filter(fields, (o, i) => {
      return o.name === 'bank_account';
    });
    let dateSelector = filter(fields, (o, i) => {
      return o.name === 'date';
    });

    dateSelector[0].disabled = isReconciliation ? true : false;
    journalType[0].disabled = isReconciliation ? true : false;
    formType[0].disabled = isReconciliation ? true : false;

    rekeningSelector[0].handleSearchContent = onSearchBankAccount;
    rekeningSelector[0].async = true;

    if (tipe === "2") {
      let unitSelector = filter(fields, (o, i) => {
        return o.name === 'unit';
      });
      let typeSelector = filter(fields, (o ,i) => {
        return o.name === 'type';
      }) || [{}];

      unitSelector[0].label = (isDebit) ? unitSelector[0].label : 'Unit Sumber';
      unitSelector[0].handleSearchContent = onSearchUnit;
      unitSelector[0].async = true;
      unitSelector[0].disabled = isReconciliation ? true : false;

      fields = filter(fields, field => field.name !== 'pos');
    } else {
      fields = filter(fields, (o) => {
        return o.name !== 'unit'
      });
    }

    if (showEdit) {
      //fields = dropRight(fields);
    }

    return (
      <ListForm
        form={form}
        coa={coa}
        formFields={fields}
        onFormChange={onFormChange}
      />
    );
  }
}

BankJournalFormHeader.propTypes = {
  form: PropTypes.object,
  coa: PropTypes.object,
  showEdit: PropTypes.bool,
  onFormChange: PropTypes.func,
  isDebit: PropTypes.bool,
  onSearchUnit: PropTypes.func,
  onSearchBankAccount: PropTypes.func,
};

BankJournalFormHeader.defaultProps = {
  form: {},
  coa: {},
  showEdit: true,
  onFormChange: noop,
  isDebit: false,
  onSearchUnit: noop,
  onSearchBankAccount: noop,
};
